export default __webpack_public_path__ + "static/media/alert.c55f18d5.svg";